import { swSettings } from "app/common/services/swSettings";
import getUserInfo from "app/components/ContactUs/getContactUsUserInfo";
import ContactUsService from "app/services/ContactUsService";

export const requestFeature = (hookId: string): Promise<Response> => {
    const formLocationUrl = window.location.href;
    const { firstName, lastName, email, phone } = getUserInfo();

    return ContactUsService.submitHook({
        firstName,
        lastName,
        email,
        phone,
        planId: swSettings.user.plan,
        message: "",
        subject: `Contact Sales: ${hookId}`,
        company: "",
        formLocationUrl,
    });
};
